import React from "react";

import PropTypes from "prop-types";
import { FormattedMessage, useIntl } from "react-intl";

import { Link } from "ds/Button";
import Dialog from "ds/Dialog";

import { Name, MetricNameLayout } from "./Metric.styles";

const MetricName = ({ name = "", kind, serviceKind = "" }) => {
  const intl = useIntl();
  const tooltipTranslationKey = `metrics.${kind}.${name}.tooltip`;
  const tooltipDocumentationKey = `links.documentation.metrics.${kind}`;
  const displayServiceKind =
    serviceKind === "Webapp" ? "Application" : serviceKind;

  let children = name ? <Name>{name}</Name> : null;

  const dialog = kind && intl.messages[tooltipTranslationKey] && (
    <Dialog
      analyticId="metric_name"
      align="center"
      description={
        <FormattedMessage
          id={tooltipTranslationKey}
          values={{ serviceKind: displayServiceKind }}
        />
      }
      link={
        <Link
          analyticId="learnmore"
          href={intl.formatMessage({ id: tooltipDocumentationKey })}
        >
          {intl.formatMessage({ id: "learnmore" })}
        </Link>
      }
    />
  );

  // Has translations
  if (["cpu", "memory"].includes(name)) {
    children = (
      <MetricNameLayout>
        <Name>
          {intl.formatMessage({
            id: `metrics.dedication.${name}.title`,
            defaultMessage: name
          })}
        </Name>

        {dialog}
      </MetricNameLayout>
    );
  } else if (["/mnt", "/tmp"].includes(name)) {
    children = (
      <MetricNameLayout>
        <Name>
          <FormattedMessage id={`metrics.grid.${name}`} />
        </Name>
        {name === "/tmp" && !intl.messages[tooltipTranslationKey] && (
          <Dialog
            analyticId="metric_tmp"
            align="center"
            title={intl.formatMessage({
              id: "metrics.grid./tmp.tooltip.title"
            })}
            description={intl.formatMessage({
              id: "metrics.grid./tmp.tooltip.description"
            })}
            link={
              <Link
                analyticId="learnmore"
                href={intl.formatMessage({ id: "links.documentation.metric" })}
              >
                {intl.formatMessage({ id: "learnmore" })}
              </Link>
            }
          />
        )}
        {dialog}
      </MetricNameLayout>
    );
  }

  return children;
};

MetricName.propTypes = {
  name: PropTypes.string,
  kind: PropTypes.string,
  serviceKind: PropTypes.string
};

export default MetricName;
